import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utils/utils";

export const blogColumns = (handleEdit, handleDelete, PAGE_SIZE, API_URL) => [
  {
    label: "S.No",
    width: 50,
    render: (row, index, page) => (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Image",
    width: 90,
    render: (row) =>
      row.imageList ? (
        <img
          src={getImageUrl(row.imageList)}
          alt={row.title}
          style={{ width: 60, height: 45, objectFit: "contain" }}
        />
      ) : (
        "-"
      ),
  },
  {
    label: "Title",
    key: "title",
    render: (row) => <span>{row.title}</span>,
  },
  {
    label: "Slug",
    key: "slug",
    render: (row) => <span>{row.slug}</span>,
  },
  {
    label: "Publish Date",
    key: "publishDate",
    render: (row) =>
      row.publishDate
        ? new Date(row.publishDate).toLocaleString()
        : "-",
  },
  {
    label: "Publish Status",
    key: "publishStatus",
    width: 120,
    render: (row) => (
      <span className={row.publishStatus === "Publish" ? "text-success" : "text-warning"}>
        {row.publishStatus}
      </span>
    ),
  },
  {
    label: "Status",
    key: "status",
    width: 120,
    render: (row) => (
      <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
    ),
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link to="#" onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
